(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  Quick add to cart                                                  */
  /* ------------------------------------------------------------------ */
  function getAddUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
      return window.theme.routes.cartAdd;
    }
    return '/cart/add.js';
  }

  function quickAdd(variantId, trigger) {
    if (!variantId) return;
    if (trigger) trigger.classList.add('is-loading');

    fetch(getAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (trigger) trigger.classList.remove('is-loading');

        if (!result.ok) {
          var message = result.data && result.data.description ? result.data.description : 'Unable to add product to cart.';
          window.alert(message);
          return;
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: result.data }
        }));
      })
      .catch(function (err) {
        if (trigger) trigger.classList.remove('is-loading');
        console.error('Quick add failed', err);
      });
  }

  /* ------------------------------------------------------------------ */
  /*  Helpers (ES5 only — no optional chaining / modern-only APIs)       */
  /* ------------------------------------------------------------------ */

  // Find the main product-card image (NOT the secondary hover image).
  function getCardImage(card) {
    var img = card.querySelector('.grid__image-ratio img');
    if (!img) img = card.querySelector('.image-wrap img');
    if (!img) {
      var imgs = card.querySelectorAll('.grid-product__image-mask img');
      for (var i = 0; i < imgs.length; i++) {
        if (!imgs[i].closest('.grid-product__secondary-image')) {
          img = imgs[i];
          break;
        }
      }
    }
    return img;
  }

  // Snapshot the card's original image + price once, so hover can restore it.
  function ensureOriginal(card) {
    if (card.getAttribute('data-fx-orig') === '1') return;
    var img = getCardImage(card);
    if (img) {
      card.__fxSrc = img.getAttribute('src') || '';
      card.__fxSrcset = img.getAttribute('srcset') || '';
      card.__fxSizes = img.getAttribute('sizes') || '';
    }
    var price = card.querySelector('.js-grid-price');
    card.__fxPrice = price ? price.innerHTML : '';
    var compare = card.querySelector('.grid-product__price--original');
    card.__fxCompare = compare ? compare.innerHTML : '';
    card.__fxCompareDisplay = compare ? compare.style.display : '';
    card.__fxHasCompare = !!compare;
    card.setAttribute('data-fx-orig', '1');
  }

  // Mobile Safari keeps painting the old responsive candidate unless EVERY
  // source is overwritten. We point srcset itself at the new single URL
  // (so there is no competing candidate), clear sizes / lazyload hints,
  // and force a decode/repaint.
  function swapCardImage(card, url) {
    if (!url) return;
    var img = getCardImage(card);
    if (!img) return;

    // Handle a <picture> wrapper if the theme ever uses one.
    var picture = img.parentNode && img.parentNode.tagName === 'PICTURE' ? img.parentNode : null;
    if (picture) {
      var sources = picture.getElementsByTagName('source');
      for (var s = 0; s < sources.length; s++) {
        sources[s].setAttribute('srcset', url);
        sources[s].removeAttribute('data-srcset');
        sources[s].removeAttribute('sizes');
      }
    }

    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-sizes');
    img.removeAttribute('sizes');
    img.classList.add('lazyloaded');
    img.classList.remove('lazyload', 'lazypreload');
    // Make the lazy/responsive engine resolve to our URL only.
    img.setAttribute('srcset', url);
    img.setAttribute('src', url);
    img.src = url;
    // iOS Safari sometimes needs an explicit, eager (re)load.
    img.loading = 'eager';
    img.removeAttribute('loading');

    // Force Safari to repaint the new bitmap instead of the cached one.
    if (typeof img.decode === 'function') {
      try { img.decode().catch(function () {}); } catch (e) {}
    }
  }

  function restoreCardImage(card) {
    var img = getCardImage(card);
    if (!img) return;
    if (card.__fxSrcset) { img.setAttribute('srcset', card.__fxSrcset); } else { img.removeAttribute('srcset'); }
    if (card.__fxSizes) { img.setAttribute('sizes', card.__fxSizes); } else { img.removeAttribute('sizes'); }
    if (card.__fxSrc) img.setAttribute('src', card.__fxSrc);
  }

  function updateCardPrice(card, priceHtml) {
    if (!priceHtml) return;
    var el = card.querySelector('.js-grid-price');
    if (el) el.innerHTML = priceHtml;
  }

  // Update the strikethrough compare-at price. Empty value = variant not on
  // sale, so hide the strikethrough; non-empty = swap to the new variant's
  // compare price and keep it visible.
  function updateCardComparePrice(card, compareHtml) {
    var el = card.querySelector('.grid-product__price--original');
    if (!el) return;
    if (compareHtml) {
      el.innerHTML = compareHtml;
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }

  function restoreCardComparePrice(card) {
    var el = card.querySelector('.grid-product__price--original');
    if (!el || !card.__fxHasCompare) return;
    if (typeof card.__fxCompare === 'string') el.innerHTML = card.__fxCompare;
    el.style.display = card.__fxCompareDisplay || '';
  }

  function getPreviews(card) {
    return card.querySelectorAll('.js-variant-preview[data-variant-id]');
  }

  function findPreview(target) {
    if (!target || !target.closest) return null;
    return target.closest('.js-variant-preview[data-variant-id]');
  }

  // Temporary preview (hover) — image + price only, no selection / cart change.
  function previewVariant(card, preview) {
    ensureOriginal(card);
    if (preview.getAttribute('data-variant-image')) {
      swapCardImage(card, preview.getAttribute('data-variant-image'));
    }
    updateCardPrice(card, preview.getAttribute('data-variant-price'));
    updateCardComparePrice(card, preview.getAttribute('data-variant-compare-price'));
  }

  // Restore the card to its committed (selected) variant, or the original.
  function restoreCard(card) {
    var sel = card.querySelector('.js-variant-preview.is-selected');
    if (sel && sel.getAttribute('data-variant-image')) {
      swapCardImage(card, sel.getAttribute('data-variant-image'));
    } else {
      restoreCardImage(card);
    }
    if (sel && sel.getAttribute('data-variant-price')) {
      updateCardPrice(card, sel.getAttribute('data-variant-price'));
    } else {
      var el = card.querySelector('.js-grid-price');
      if (el && typeof card.__fxPrice === 'string') el.innerHTML = card.__fxPrice;
    }
    if (sel) {
      updateCardComparePrice(card, sel.getAttribute('data-variant-compare-price'));
    } else {
      restoreCardComparePrice(card);
    }
  }

  // Commit a variant to a card: active state, image, price, cart id.
  function applyVariant(card, preview) {
    var variantId = preview.getAttribute('data-variant-id');
    if (!variantId) return;

    ensureOriginal(card);

    var previews = getPreviews(card);
    for (var i = 0; i < previews.length; i++) {
      previews[i].classList.remove('is-selected');
      previews[i].setAttribute('aria-pressed', 'false');
    }
    preview.classList.add('is-selected');
    preview.setAttribute('aria-pressed', 'true');

    swapCardImage(card, preview.getAttribute('data-variant-image'));
    updateCardPrice(card, preview.getAttribute('data-variant-price'));
    updateCardComparePrice(card, preview.getAttribute('data-variant-compare-price'));

    var addBtn = card.querySelector('.grid-product__add-to-cart[data-quick-add]');
    if (addBtn) addBtn.setAttribute('data-variant-id', variantId);
  }

  /* ------------------------------------------------------------------ */
  /*  Delegated handlers (bound once on `document`, so they survive      */
  /*  section / theme-customizer reloads)                                */
  /* ------------------------------------------------------------------ */

  // Commit the tapped/clicked preview to its card. Returns true if handled.
  function commitFromEvent(event) {
    var preview = findPreview(event.target);
    if (!preview) return false;

    var card = preview.closest('.grid-product');
    if (!card) return false;

    // Stop the swatch <a> from navigating and stop the card link too.
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();

    applyVariant(card, preview);
    return true;
  }

  function handlePreviewSelect(event) {
    commitFromEvent(event);
  }

  function isMousePointer(event) {
    // Only hover-preview for a real mouse; tap on touch should commit instead.
    return !event.pointerType || event.pointerType === 'mouse';
  }

  function handlePreviewHover(event) {
    if (!isMousePointer(event)) return;
    var preview = findPreview(event.target);
    if (!preview) return;
    var card = preview.closest('.grid-product');
    if (!card) return;
    previewVariant(card, preview);
  }

  function handlePreviewOut(event) {
    if (!isMousePointer(event)) return;
    var preview = findPreview(event.target);
    if (!preview) return;
    var card = preview.closest('.grid-product');
    if (!card) return;

    // Moving to another preview in the SAME card — keep previewing.
    var to = event.relatedTarget;
    if (to && to.closest) {
      var toPrev = to.closest('.js-variant-preview[data-variant-id]');
      if (toPrev && toPrev.closest('.grid-product') === card) return;
    }
    restoreCard(card);
  }

  function handleAddToCart(event) {
    var trigger = event.target.closest('.grid-product__add-to-cart[data-quick-add]');
    if (!trigger) return;
    if (trigger.hasAttribute('disabled') || trigger.getAttribute('aria-disabled') === 'true') return;

    var variantId = trigger.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();
    event.stopPropagation();

    quickAdd(variantId, trigger);
  }

  /* --- Touch (mobile Safari) -------------------------------------------
     iOS Safari fires the <a> navigation from the tap before a delegated
     click reliably commits. We commit on `touchend` (capture) and cancel
     the navigation + the ghost click it would generate. A touchmove guard
     prevents committing while the user is scrolling.                      */
  var lastTouchCommit = 0;
  var touchMoved = false;

  document.addEventListener('touchstart', function () {
    touchMoved = false;
  }, true);

  document.addEventListener('touchmove', function () {
    touchMoved = true;
  }, true);

  document.addEventListener('touchend', function (event) {
    if (touchMoved) return;
    if (event.touches && event.touches.length > 1) return;
    if (commitFromEvent(event)) {
      lastTouchCommit = Date.now();
    }
  }, true);

  /* --- Click (desktop + ghost-click suppression) ----------------------- */
  document.addEventListener('click', function (event) {
    // Suppress the ghost click Safari fires ~300ms after a handled tap.
    if (Date.now() - lastTouchCommit < 800) {
      var p = findPreview(event.target);
      if (p) {
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
    commitFromEvent(event);
  }, true);

  /* --- Pointer fallback (pen / touch where touch events are absent) ---- */
  document.addEventListener('pointerup', function (event) {
    if (event.pointerType === 'mouse') return;            // mouse -> click
    if (Date.now() - lastTouchCommit < 800) return;       // already handled
    if (commitFromEvent(event)) lastTouchCommit = Date.now();
  }, true);

  // Hover preview — mouse only (handlers already gate on pointerType).
  document.addEventListener('pointerover', handlePreviewHover);
  document.addEventListener('pointerout', handlePreviewOut);
  if (!window.PointerEvent) {
    document.addEventListener('mouseover', handlePreviewHover);
    document.addEventListener('mouseout', handlePreviewOut);
  }

  document.addEventListener('click', handleAddToCart);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    if (findPreview(event.target)) {
      handlePreviewSelect(event);
    } else if (event.target.closest('.grid-product__add-to-cart[data-quick-add]')) {
      handleAddToCart(event);
    }
  });
})();

/* -------------------------------------------------------------------- */
/*  Variant aux-link → inline guide-gallery popup                        */
/*  Toggles a modal that's pre-rendered (with default + editable content)*/
/*  by the featured-product section. The OwlCarousel inside boots only   */
/*  once the modal first opens — otherwise it measures width 0 while     */
/*  hidden and the slides collapse.                                      */
/* -------------------------------------------------------------------- */
(function () {
  'use strict';

  function findModal(triggerEl) {
    var sectionWrap = triggerEl.closest('[id^="shopify-section-"]');
    if (!sectionWrap) return null;
    return sectionWrap.querySelector('.fp-guide-modal');
  }

  function openModal(modal) {
    modal.classList.add('is-open');
    document.body.classList.add('fp-guide-modal-open');

    // Lazy-init the carousel the first time we show the modal. We need to
    // wait for jQuery + Owl to be available, since they're loaded async
    // from CDNs by the section itself.
    if (!modal.dataset.fpGuideBooted) {
      modal.dataset.fpGuideBooted = '1';
      var init = modal.__fpGuideInit;
      if (typeof init === 'function') {
        waitForOwl(init);
      }
    } else {
      // Re-trigger Owl's refresh in case the viewport changed while closed.
      var container = modal.querySelector('.guide-gallery-container.owl-carousel');
      if (container && window.jQuery) {
        try { window.jQuery(container).trigger('refresh.owl.carousel'); } catch (e) {}
      }
    }
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    document.body.classList.remove('fp-guide-modal-open');
  }

  function waitForOwl(callback, attempts) {
    attempts = attempts || 0;
    if (attempts > 80) return; // ~8 seconds
    if (typeof window.jQuery !== 'undefined' && window.jQuery.fn && window.jQuery.fn.owlCarousel) {
      callback();
      return;
    }
    setTimeout(function () { waitForOwl(callback, attempts + 1); }, 100);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.variant__aux-link');
    if (trigger) {
      var modal = findModal(trigger);
      if (!modal) return;
      e.preventDefault();
      openModal(modal);
      return;
    }
    var closer = e.target.closest('[data-fp-guide-close]');
    if (closer) {
      var m = closer.closest('.fp-guide-modal');
      if (m) closeModal(m);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.fp-guide-modal.is-open');
    if (open) closeModal(open);
  });
})();

/* ------------------------------------------------------------------ */
/*  Currency selector inside the mobile nav drawer                      */
/*  The drawer markup is rendered outside [data-section-type="header"], */
/*  so the header section's own initDisclosures() never reaches it.     */
/* ------------------------------------------------------------------ */
(function () {
  'use strict';

  function initDrawerCurrency() {
    if (!window.theme || !window.theme.Disclosure) return;

    var el = document.querySelector('#NavDrawer [data-disclosure-currency]');
    if (!el || el.dataset.disclosureReady === 'true') return;

    el.dataset.disclosureReady = 'true';
    new window.theme.Disclosure(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerCurrency);
  } else {
    initDrawerCurrency();
  }

  // theme editor re-renders the header (and with it the drawer)
  document.addEventListener('shopify:section:load', initDrawerCurrency);
})();
